import { useMutation, useQueryClient } from '@tanstack/react-query';

import type AgentApiCandidateMailTemplatesRecord from '@/types/serializers/AgentApiCandidateMailTemplatesRecord';

export interface UpdateCandidateMailTemplateRequest {
  id: number;
  name: string;
  subject: string;
  body: string;
}

export default function useUpdateCandidateMailTemplate() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement)?.content ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['candidateMailTemplates'] }),
    mutationFn: async (
      params: UpdateCandidateMailTemplateRequest
    ): Promise<AgentApiCandidateMailTemplatesRecord> => {
      const response = await fetch(`/agent/api/candidate_mail_templates/${params.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          candidate_mail_template: {
            name: params.name,
            subject: params.subject,
            body: params.body,
          },
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update candidate mail template');
      }

      return await response.json();
    },
  });
}
